import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import ApplyCta from './ApplyCta';

/**
 * AboutHero (About Page Hero)
 * - Full-bleed Hawa Mahal architectural image (/about-background.webp) as background
 * - Text placed in a frosted transparent panel with subtle border matching reference image
 * - Exact content, typography, and left-alignment preserved
 */
export default function AboutHero() {
  return (
    <section
      id="about-hero"
      className="relative min-h-[92vh] lg:min-h-screen overflow-hidden bg-[#08080a] pt-28 sm:pt-32 pb-16 sm:pb-20 lg:pb-24 flex items-center"
    >
      {/* Full Background Hawa Mahal Architectural Heritage Image */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <img
          src="/about-background.webp"
          alt="Hawa Mahal Jaipur Architectural Heritage"
          className="w-full h-full object-cover object-center brightness-90 contrast-105 select-none"
        />
        {/* Light uniform tint + soft top/bottom blend into site theme */}
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-[#08080a] via-[#08080a]/60 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#08080a] via-[#08080a]/60 to-transparent" />
      </div>

      {/* Main Container */}
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-6 sm:py-10 w-full z-10 flex justify-start">
        <div className="w-full max-w-[620px] lg:max-w-[640px]">
          {/* Card with subtle border and light transparent layer matching reference image */}
          <div className="rounded-2xl sm:rounded-3xl bg-black/60 p-6 sm:p-9 md:p-11 shadow-2xl shadow-black/90 relative">
            {/* About Hero Heading */}
            <h1 className="reveal-up font-bold tracking-tight text-white leading-[1.12] text-2xl sm:text-3xl md:text-4xl lg:text-[42px] xl:text-[45px]">
              Alongside every enduring enterprise is a{' '}
              <span className="text-[#d42b92]">deliberate journey</span> of creation.
            </h1>

            {/* About Hero Body Narrative */}
            <div className="reveal-up mt-6 space-y-4 text-white/80 text-[14px] sm:text-[15.5px] leading-relaxed font-normal">
              <p>
                Born in Jaipur, Innovher is inspired by a city that values craft over speed and legacy over applause. Innovation is easy to begin; building sustainable businesses is harder. Innovher combines venture-building discipline, governance, capital, and execution to help founders create businesses that matter.
              </p>

              <div className="py-2.5 space-y-1.5 border-y border-white/10">
                <p className="text-white font-medium">
                  Capital follows <strong className="font-bold text-white">progress.</strong>
                </p>
                <p className="text-white font-medium">
                  Growth follows <strong className="font-bold text-white">readiness.</strong>
                </p>
              </div>

              <p className="text-white/80">
                And when the time is right, ventures move forward, prepared for scale, investment, and long-term success.
              </p>

              <p className="italic text-[#ff8ec5] font-semibold text-base sm:text-lg pt-1">
                Enduring enterprises built, not rushed.
              </p>
            </div>

            {/* About Hero CTAs & Destinations */}
            {/* <div className="reveal-up mt-7 flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3">
              <ApplyCta to="/contact" label="Build With Us" size="md" />
              <a
                href="#journey"
                className="px-5 py-2.5 rounded-full text-white/90 border border-white/20 hover:border-[#d42b92] hover:text-[#d42b92] transition-colors text-xs sm:text-sm font-medium inline-flex items-center gap-2"
              >
                <span>Our Journey</span>
                <ArrowUpRight className="w-3.5 h-3.5 text-[#ff8ec5]" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
